export const FILTER_MENU_CONFIG = Object.freeze({
  ANIMATION: {
    DURATION_MS: 300,
    EASE_IN: 'ease-in',
    EASE_OUT: 'ease-out',
    TRANSFORM_OPEN: '0',
    TRANSFORM_CLOSED: '100%',
  },
  Z_INDEX: {
    DIALOG: 9999999999,
    DROPDOWN: 1,
  },
  DIMENSIONS: {
    ICON_SIZE: 16,
    CLOSE_BUTTON_SIZE: 24,
    MIN_DROPDOWN_WIDTH: 220,
    DESKTOP_DIALOG_WIDTH: 401,
  },
} as const);
